import AppTd from "@/components/AppTd";
import AppPopover from "@/components/AppPopover";
export default {
  name: "SeoCategoryCell",
  props: {
    item: Object
  },
  components: {
    AppTd,
    AppPopover
  },
  computed: {
    id() {
      return crypto.randomUUID();
    }
  }
};